import { initReactI18next } from 'react-i18next';
import { logError } from '@ff-os/shared-utils/logging';
import i18next from 'i18next';

const resources = {
    'en-US': { translation: require('./en-US.json') },
    'fr-BE': { translation: require('./fr-BE.json') },
    'nl-NL': { translation: require('./nl-NL.json') },
    'de-DE': { translation: require('./de-DE.json') }
};

export const createReactI18n = (language: string) => {

    const options = {
        lng: language,
        fallbackLng: 'en-US',
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
        resources
    };

    i18next
        .use(initReactI18next)
        .init(options)
        .catch(logError);

    return i18next;
};

export const createI18n = (language: string) => {

    const options = {
        lng: language,
        fallbackLng: 'en-US',
        interpolation: { escapeValue: false },
        resources
    };

    return i18next
        .init(options)
        .catch(logError);
};

export const findLanguage = <T extends string>(
    languages: Readonly<T[]>,
    language: T
): T | undefined => {
    if (languages.includes(language)) {
        return language;
    } else {
        return languages.find(l => l.startsWith(language.split('-')[0]));
    }
};